import { OrdersApi } from '@/api/generated/fetch-client';
import { Preorder } from '@/app/pages/preorder/preorder';
import { createFileRoute } from '@tanstack/react-router';

import { OrderApi } from '@/features/order/api';
import { preorderInfoSearchSchema } from '@/features/order/config/preorder-info-search-schema';
import { useGetPreorderInfo } from '@/features/order/hooks/use-get-preorder-info';
import { OrderRepository } from '@/features/order/repository/order-repository';

export const Route = createFileRoute('/preorder/')({
  validateSearch: preorderInfoSearchSchema,
  component: Preorder,
  loaderDeps: ({ search }) => ({ ...search }),
  context: ({ context }) => {
    new OrderRepository(new OrderApi(new OrdersApi(context.configuration)));
  },
  loader: async ({ context: { orderRepository, queryClient }, deps }) => {
    const preorder = await queryClient.ensureQueryData(
      useGetPreorderInfo.options({ repository: orderRepository, ...deps }),
    );
    return { preorder };
  },
});
